import classie from './classie';

/**
 * svganimations.js v1.0.0
 * http://www.codrops.com
 *
 * the svg path animation is based on http://24ways.org/2013/animating-vectors-with-svg/ by Brian Suda (@briansuda)
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */

function SVGEl( el ) {
  this.el = el;
  this.imageInner = this.el.previousElementSibling;
  this.image = this.el.previousElementSibling.previousElementSibling;
  this.current_frame = 0;
  this.total_frames = 60;
  this.path = [];
  this.length = [];
  this.handle = 0;
  this.init();
}

SVGEl.prototype.init = function() {
  var self = this;
  [].slice.call( this.el.querySelectorAll( 'path' ) ).forEach( function( path, i ) {
    self.path[i] = path;
    var l = self.path[i].getTotalLength();
    self.length[i] = l;
    self.path[i].style.strokeDasharray = l + ' ' + l; 
    self.path[i].style.strokeDashoffset = l;
  } );
};

SVGEl.prototype.render = function() {
  if( this.rendered ) return;
  this.rendered = true;
  this.draw();
};

SVGEl.prototype.draw = function() {
  const self = this,
    progress = this.current_frame/this.total_frames;
  if (progress > 1) {
    cancelAnimationFrame(this.handle);
    this.showImage();
  } else {
    this.current_frame++;
    for(var j=0, len = this.path.length; j<len;j++){
      this.path[j].style.strokeDashoffset = Math.floor(this.length[j] * (1 - progress));
    }
    this.handle = requestAnimationFrame(function() { self.draw(); });
  }
};

SVGEl.prototype.showImage = function() {
  if(this.image) {
    classie.add(this.image, 'show');
  }
  classie.add(this.imageInner, 'show');
  classie.add(this.el, 'hide');
};

const drawSVG = (el)=> {
  const svg = new SVGEl(el);
  svg.render();
}

export default drawSVG;